import { stringify } from "query-string";
import { DataSourceId, TemplateId } from "../../globalTypes";
import { DeleteRowPayload } from "./types";
import { GetControllerNameByDbContext } from "../../utils/global";

export const deleteRow = ({
  dbContext,
  tableName,
  keyValue,
  templateId,
}: DeleteRowPayload) =>
  `api/${GetControllerNameByDbContext(dbContext)}/DeleteTableRow/${keyValue}?` +
  `tableName=${tableName}&` +
  `templateId=${templateId}`;

export const deleteRowByTemplateId = (
  templateId: TemplateId,
  keyValue: string | number
) => `api/Database/Row/ByTemplateId/${keyValue}?templateId=${templateId}`;

export const getTableColumns = (
  dataSourceId: DataSourceId,
  tableName: string
) =>
  `/api/Database/TableColumns` +
  `?datasourceId=${dataSourceId}&tableName=${tableName}`;

export const getTableNamesByDataSourceId = (dataSourceId: string) =>
  `api/Database/Tables?datasourceId=${dataSourceId}`;

export const getAdministrationAppTable = (
  pageNum: number | undefined,
  maxRowsPerPage: number | undefined,
  orderSearch: string | undefined,
  hiddenColumnNames: string[],
  fulltextKeyword: string | undefined
) => {
  const queryString = stringify({
    pageNum,
    maxPageRowCount: maxRowsPerPage,
    orderSearch,
    fulltextKeyword,
  });

  let url = `api/Tables/GetTable?${queryString}`;

  hiddenColumnNames.forEach((column) => {
    url += `&ignoreColumns=${column}`;
  });
  return url;
};

export const getAppTables = () => "api/Tables";

export const posAdministrationAppTableRow = () => "api/Tables";

export const deleteAdministrationAppTableRow = (keyValue: string | number) =>
  `api/Tables/${keyValue}`;

export const updateAdministrationAppTableRow = (keyValue: string | number) =>
  `api/Tables/${keyValue}`;

export const getOverviewTablesForTemplateIds = () =>
  "/api/Database/Table/ByTemplateIds";

export const updateTableSchema = (tableId: number) =>
  `/api/Tables/UpdateColumnSchema/${tableId}`;
